module.exports = __webpack_public_path__ + "img/masterclass_female.90224ac6.jpg";